import { Injectable, inject } from "@angular/core";
import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { Visit, Visit_DetailProjection } from "@app/models/rest/visit";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { VisitRestService } from "@app/services/hal/visit-rest.service";
import { Job } from "@app/models/rest/job";
import { VisitType } from "@app/models/rest/visit-type";
import { VisitStatus } from "@app/models/enums/visit-status.enum";
import { TicketStore } from "@app/services/store/ticket-store";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";

@Injectable({
  providedIn: "root"
})
export class VisitStore extends RealTimeDataStore<Visit> {
  ticketStore = inject(TicketStore);

  constructor() {
    const visitRestService = inject(VisitRestService);
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(visitRestService, webStompSubscriber, hateoasResourceService);
    super.subscribeToMessaging("Visit");
  }

  update(entity: Visit) {
    return super.update(entity);
  }

  addNewVisit(job: Job, visitType: VisitType, duration: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      let visit: Visit = <Visit>(<unknown>{
        visitStatus: VisitStatus.NEW,
        job: job,
        visitType: visitType
      });
      this.create(visit).subscribe(
        async (value: Visit) => {
          this.loadSingleProjection<Visit_DetailProjection>(
            Visit_DetailProjection,
            value.id,
            "detail"
          ).then((savedVisit) => {
            let promises = [];

            savedVisit.ticketList.forEach((ticket) => {
              promises.push(
                new Promise((resolve1, reject1) => {
                  this.ticketStore
                    .loadSingle(ticket.id, true)
                    .then((value1) => {
                      value1.duration = duration;
                      this.ticketStore.update(value1).subscribe(
                        (value1) => {
                          resolve1(null);
                        },
                        (error1) => reject()
                      );
                    });
                })
              );
            });
            console.log(promises.length);
            console.log(promises);
            Promise.all(promises).then(
              (value1) => {
                console.log("promises complete");
                console.log(value1);
                resolve(value);
              },
              (reason) => {
                reject(reason);
              }
            );
          });
        },
        (error1) => {
          reject(error1);
        }
      );
    });
  }
}
